import { toast } from 'react-toastify';
import {
  BNS3_ALL_CATEGORY,
  BNS3_MAX_TITLE_LENGTH,
  FAVORITE_LOTS_PAGE,
  LOCAL_TOKEN_EXPIRATION_INTERVAL,
  MY_LOTS_PAGE,
} from '../constants';

export const formatValue = value => {
  if (Array.isArray(value)) {
    return value;
  }
  if (!value) {
    return [];
  }
  return [value];
};

export const preventNonNumericalInput = evt => {
  const e = evt || window.event;
  const charCode = typeof e.which === 'undefined' ? e.keyCode : e.which;
  if (
    charCode === 8 ||
    charCode === 9 ||
    charCode === 35 ||
    charCode === 36 ||
    charCode === 37 ||
    charCode === 39 ||
    charCode === 46 ||
    charCode === 96 ||
    charCode === 97 ||
    charCode === 98 ||
    charCode === 99 ||
    charCode === 100 ||
    charCode === 101 ||
    charCode === 102 ||
    charCode === 103 ||
    charCode === 104 ||
    charCode === 105
  )
    return;

  if (e.shiftKey) {
    evt.preventDefault();
  }

  const charStr = String.fromCharCode(charCode);

  if (!charStr.match(/^[0-9]+$/)) {
    evt.preventDefault();
  }
};

export const renderError = (errors, field, touched) => {
  const errorElement = <p className="bns3-form-validation">{errors[field]}</p>;

  if (errors[field] && touched[field]) {
    return errorElement;
  }

  return null;
};

export const displayErrorMessage = error => {
  // If an error is provided as a string
  if (typeof error === 'string') {
    return toast.error(error);
  }

  // If an error is provided as an object
  if (error.response && error.response.data) {
    if (error.response.data.errors && Array.isArray(error.response.data.errors)) {
      error.response.data.errors.forEach(message => toast.error(message));
    }
  }
  // Default error
  return toast.error('An error happened while trying to perform request...');
};

export const displayMessage = info => {
  toast.info(info);
};

const sessionStorageKey = 'currentLocation';

export const setCurrentLocation = location => {
  sessionStorage.setItem(sessionStorageKey, location);
};

export const getCurrentLocation = () => {
  const location = sessionStorage.getItem(sessionStorageKey);
  if (location) return location;
  return '/';
};

export const filterInt = value => {
  if (/^[-+]?(\d+|Infinity)$/.test(value.trim())) {
    return Number(value);
  }
  return NaN;
};

export const stripHtml = html => {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

export const urlFromValues = values => {
  let str = '';
  for (const key in values) {
    if (values[key].toString().length > 0) {
      if (str !== '') {
        str += '&';
      }
      str += `${key}=${values[key]}`;
    }
  }
  return str;
};

export const clearCurrentLocation = () => sessionStorage.setItem(sessionStorageKey, null);

// expects Date string: "2021-03-11T15:00:35.7479791"
export function convertApiDateToUtcDate(apiDateTime) {
  const str = String(apiDateTime);
  return new Date(str.endsWith('Z') ? str : `${str}Z`);
}

export const formatMessageTime = date => {
  return `${`0${date.getHours()}`.slice(-2)}:${`0${date.getMinutes()}`.slice(-2)}`;
};

export const formatMessageDate = date => {
  return `${`${date.getFullYear()}`}-${`0${date.getMonth() + 1}`.slice(-2)}-${`0${date.getDate()}`.slice(-2)}`;
};

export const formatConvertedPrice = price => {
  if (price > 0 && price < 0.01) {
    return '<0.01';
  }
  const formatted = price.toFixed(2);
  return formatted;
};

//date format 29-4-2022 13:59
export const dateWithTime = () => {
  const d = new Date();
  return d.getDate() + '-' + (d.getMonth() + 1) + '-' + d.getFullYear() + ' ' + d.getHours() + ':' + d.getMinutes();
};

export const filterObjectNull = object => {
  const objectToFilter = { ...object };
  Object.keys(objectToFilter).forEach(key => objectToFilter[key] === null && delete objectToFilter[key]);
  return objectToFilter;
};

export const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      func.apply(this, args);
    }, wait);
  };
};

export const makeAddress = addressObject => {
  const address = [];
  if (addressObject.road) {
    address.push(addressObject.road);
  }
  if (addressObject.house_number) {
    address.push(addressObject.house_number);
  }
  if (addressObject.city) {
    address.push(addressObject.city);
  } else if (addressObject.town) {
    address.push(addressObject.town);
  } else if (addressObject.village) {
    address.push(addressObject.village);
  } else if (addressObject.county) {
    address.push(addressObject.county);
  }
  if (addressObject.country) {
    address.push(addressObject.country);
  }
  return address.join(', ');
};

export const countSymbolsToLeft = length => `${BNS3_MAX_TITLE_LENGTH - length}/${BNS3_MAX_TITLE_LENGTH}`;

export const pickCoverImage = (imagesList, uid, id) => {
  let updatedImagesList = [];

  if (id) {
    updatedImagesList = imagesList.map(image => {
      if (image.id === id) {
        return { ...image, isMain: true };
      }

      return image;
    });
  } else {
    updatedImagesList = imagesList.map(image => {
      if (image.uid === uid) {
        return { ...image, isMain: true };
      }

      return image;
    });
  }
  return updatedImagesList;
};

export const addImageIndex = imagesList => {
  return imagesList.map((image, idx) => ({
    ...image,
    index: idx,
  }));
};

export const getImageIndex = (imagesCollection, index, mainImageIndex) => {
  if (index === mainImageIndex) {
    return mainImageIndex;
  }

  if (index !== null && index !== mainImageIndex) {
    return index;
  }

  if (imagesCollection.length > 0 && index === null) {
    return mainImageIndex !== null ? mainImageIndex : imagesCollection[0].index;
  }

  return 0;
};

export const getCategoryValue = (categories, id) => {
  let name;
  if (id) {
    categories.forEach(category => {
      if (category.id === Number(id)) {
        name = category.name;
      }
    });
  }
  return name;
};

export const getContactUsData = ({ isAuthenticated, email, firstName }) => {
  const data = {
    email: isAuthenticated ? email : '',
    name: isAuthenticated ? firstName : '',
    feedbackComment: '',
  };

  return data;
};

export const getLotCategoryData = (categories, selectedCategoryId) => {
  let currentParentCategory = null;
  let currentSubcategory = null;

  categories.some(category => {
    let selectedSubcategory = null;

    if (category.id === selectedCategoryId) {
      currentSubcategory = null;
      currentParentCategory = { id: category.id, name: category.name };
      return true;
    }

    if (category.subCategories) {
      selectedSubcategory = category.subCategories.find(subcategory => subcategory.id === selectedCategoryId);
      currentSubcategory = selectedSubcategory ? { id: selectedSubcategory.id, name: selectedSubcategory.name } : null;
      currentParentCategory = selectedSubcategory ? { id: category.id, name: category.name } : null;
      return !!selectedSubcategory;
    }

    return false;
  });

  return {
    category: currentParentCategory,
    subcategory: currentSubcategory,
  };
};

export const checkValueInFilters = value => {
  if (typeof value === 'string') {
    return value.split(' ');
  }
  return value;
};

export const createCategoriesDropdownOptions = categories => {
  const categoriesArray = categories.slice(1, categories.length);

  const categoriesOptionsTemplate = [BNS3_ALL_CATEGORY];

  categoriesArray.forEach(category => {
    categoriesOptionsTemplate.push({
      value: String(category.id),
      label: category.name,
      children: category.subCategories.map(subCategory => ({ value: String(subCategory.id), label: subCategory.name })),
    });
  });

  return categoriesOptionsTemplate;
};

export const createLocationsDropdownOptions = locations =>
  locations.map(locationItem => ({ value: String(locationItem.id), label: locationItem.name }));

export const removeItemFromArray = (arr, item) => arr.filter(arrItem => arrItem !== item);

export const getPageSpecificFilterByPathname = pathname => {
  switch (pathname) {
    case MY_LOTS_PAGE.href:
      return MY_LOTS_PAGE.filterParam;
    case FAVORITE_LOTS_PAGE.href:
      return FAVORITE_LOTS_PAGE.filterParam;
    default:
      return {};
  }
};

export const getExpirationDate = () => {
  const timestamp = new Date().getTime();
  const interval = 1000 * 60 * LOCAL_TOKEN_EXPIRATION_INTERVAL;
  return new Date(timestamp + interval);
};

export const getLotLocationTitle = lot => {
  if (lot?.location?.name) {
    return lot.location.name;
  }

  if (lot?.contact?.country && lot?.contact?.city) {
    return `${lot.contact.country}, ${lot.contact.city}`;
  }

  return 'No location provided';
};

export const convertStringToBoolean = value => {
  if (value.length > 0) {
    return value === 'true' ? true : false;
  }
  return null;
};

export const handleCombinedArr = (arr = null, value) => {
  if (arr) {
    return arr.includes(value) ? arr : [...arr, value];
  }
  if (!value) {
    return arr;
  }
  return value;
};

export const getWeekOfMonth = date => {
  const adjustedDate = date.getDate() + date.getDay();
  const prefixes = ['0', '1', '2', '3', '4', '5'];
  return parseInt(prefixes[0 | (adjustedDate / 7)]) + 1;
};

export const formatAMPM = date => {
  return date
    .toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })
    .toUpperCase();
};

const getDaysDifferenceFromToday = date => {
  const day = new Date(date);
  const today = new Date();

  day.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return Math.round((today - day) / (1000 * 60 * 60 * 24));
};

export const getLastMsgDate = lastMessageAdded => {
  const diff = getDaysDifferenceFromToday(lastMessageAdded);

  if (diff === 0) {
    return formatAMPM(lastMessageAdded);
  }

  if (diff < 7) {
    return lastMessageAdded.toLocaleDateString('en-us', { weekday: 'short' });
  }

  return lastMessageAdded.toLocaleDateString('en-us', { month: 'short', day: 'numeric' });
};

export const sortByID = arr => {
  return arr?.sort(function (a, b) {
    if (a.id > b.id) {
      return -1;
    }
    if (a.id < b.id) {
      return 1;
    }
    return 0;
  });
};

export const truncate = (str, max, len) => {
  return str.length > max ? str.substring(0, len) + '...' : str;
};

export const objToArr = arr => {
  let local = [];
  const obj = el => {
    return { [el[0]]: el[1] };
  };
  Object.entries(arr).forEach(el => local.push(obj(el)));
  return local;
};

export const compareArrWithExtentions = (f, s) => {
  if (!Array.isArray(s)) {
    return false;
  }
  return JSON.stringify(f) === JSON.stringify(s);
};

export const compareWithFilterExtentions = arr => {
  let local = [];
  const exeptionKeys = ['currency', 'sortingFlag', 'itemsPerPage'];
  if (arr.length > 0) {
    arr.forEach(el => {
      if (!exeptionKeys.includes(Object.keys(el)[0])) {
        local.push(el);
      }
    });
    return local;
  }
  return arr;
};

export const safeDecode = (value) => {
  if (!value) return '';
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};
